module.exports = __webpack_public_path__ + "img/spiel6.2b975bef.jpg";